import React from "react";
import { StrapiPicture } from "../picture";
import css from "./index.module.scss";

export default function ImageCard({
  headline = "",
  image = null,
  imageSizes = "",
  href = "",
  className = "",
  target = "_blank",
  jumbo = false,
  small = false,
  children,
  loading = "lazy",
}) {
  let finalClassName = `${css.card} ${className}`;
  if (jumbo){
    finalClassName += ` ${css.jumbo}`;
  }
  if (small){
    finalClassName += ` ${css.small}`;
  }


  const content = <>
    <div className={css.image}>
      <StrapiPicture picture={image} sizes={imageSizes} loading={loading}/>
    </div>
    {headline && <div className={css.cardHeadline}>{headline}</div>}
    {children && <div className={css.cardBody}>
      {children}
    </div>}
  </>;

  if (href){
    return <a
      className={`custom ${finalClassName}`}
      href={href}
      target={target}
    >
      {content}
    </a>;
  }
  return <div className={`${css.card} ${className}`}>{content}</div>;
}
